




































import Vue from 'vue';
import Component from 'vue-class-component';
import { PhaseAliasService } from '../../service/PhaseAliasService';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { DataGrid } from '@questelservices/common-vue';
import 'devextreme-vue/tag-box';
import {
  DxColumn,
  DxHeaderFilter,  
  DxDataGrid
} from 'devextreme-vue/data-grid';
import { DxPopup, DxButton } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import {SelectOption} from '../../models/SelectOption';
import { QuestelServicesClient } from '@questelservices/common';
import { PhaseAliasDto } from '../../models/PhaseAliasDto';

@Component({
  components: {
    DxDataGrid,
    DataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPopup,
    DxButton
  }
})
export default class PhaseAliasesGrid extends Vue { 
$refs: Vue['$refs'] & {   
  dataGrid?: DataGrid;
} = {};
  selectedClient: string = '';
  dataGrid: any;
  phaseAliasService: PhaseAliasService;
  phaseAliasCustomStoreOptions: DevExpress.data.CustomStoreOptions;

  constructor() {
    super();

    this.phaseAliasService = new PhaseAliasService(
      '/api/PhaseAlias'
    );

    this.phaseAliasCustomStoreOptions = {
      load: loadOptions => this.phaseAliasService.search(loadOptions),
    };

    this.loadData();    
  }

  async loadData() {
    let client = new QuestelServicesClient(this.$store, '');  
    let phaseTypes = await client.get<PhaseTypeDto[]>('/api/phasetype/all');     
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;  
  }

  editAlias(data: any): void {
    this.$emit('edit-alias', data); 
  }

  createAlias(): void {
    this.$emit('create-alias');
  }

  showDelete(data: any): void {
    this.$emit('delete-alias', data);
  }

  deleteAlias(phaseAlias: PhaseAliasDto): void {
    this.phaseAliasService.delete(phaseAlias.PhaseAliasId)
      .then(result => {
        this.refreshDataGrid();
      });
  }  

  refreshDataGrid(): void {
    if(this.$refs.dataGrid) {
          (this.$refs.dataGrid as any).refreshDataGrid();
    }  
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        width: 10,

        icon: 'plus',
        onClick: this.createAlias.bind(this)
      }
    });
  }
}
